import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const imagesSlice = createSlice({
  name: "images",
  initialState,
  reducers: {
    addImages: (state, action) => {
      return [...action.payload, ...state];
    },
    removeImage: (state, action) => {
      return state.filter((image) => image.url !== action.payload);
    },
    deleteImage: (state, action) => {
      const url = action.payload;
      const image = state.find((image) => image.url === url);
      if (image) {
        image.deleted = true;
      }
    },
    clearImages: (state) => {
      return [];
    },
    updateId: (state, action) => {
      const { url, imageId, status } = action.payload;
      const image = state.find((image) => image.url === url);
      if (image) {
        image.imageId = imageId;
        image.status = status;
      }
    },
    archiveImage: (state, action) => {
      const { url, archive } = action.payload;
      const image = state.find((image) => image.url === url);
      if (image) {
        image.archived = archive;
      }
    },
  },
});

export const {
  addImages,
  removeImage,
  clearImages,
  updateId,
  archiveImage,
  deleteImage,
} = imagesSlice.actions;

export default imagesSlice.reducer;
